<template>
  <div class="table_content">
    <div class="keyword_table">
      <el-table
        ref="table"
        size="small"
        header-cell-class-name="brand-table-header-cell"
        cell-class-name="brand-table-cell"
        v-loading="loading"
        :data="keywordList"
        height="100%"
      >
        <el-table-column prop="brandName" label="品牌"> </el-table-column>
        <el-table-column label="品牌logo" prop="enterpriseLogo">
          <template v-slot="scope">
            <div class="img_box" style="height: 100px">
              <el-image
                class="logo"
                :src="scope.row.otherBrandLogo"
                :preview-src-list="[scope.row.otherBrandLogo]"
                fit="fill"
                lazy
              >
                <div slot="error" class="image-slot">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="isCompete" label="本品/竞品" :width="100">
          <template v-slot="scope">
            <span>{{ scope.row.isCompete === 1 ? "竞品" : "本品" }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="keyword"
          label="关键词"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column prop="enterpriseName" label="企业"></el-table-column>
        <el-table-column prop="status" label="状态" :width="100">
          <template v-slot="scope">
            <span>{{ scope.row.status === 1 ? "暂停" : "正常" }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="添加时间"
          prop="createTime"
          :formatter="formaterTime"
        >
        </el-table-column>
        <el-table-column label="操作" :width="120">
          <template v-slot="scope">
            <el-button
              class="no-margin center-children"
              type="text"
              size="small"
              @click="toEdit(scope.row)"
              >编辑</el-button
            >
            |
            <el-popconfirm title="确定删除吗？" @confirm="toDel(scope.row)">
              <el-button
                slot="reference"
                class="no-margin center-children"
                type="text"
                size="small"
                >删除</el-button
              >
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div ref="pagination" class="pagination">
      <el-pagination
        :current-page="params.page"
        :page-size="params.size"
        :total="params.total"
        layout="total, prev, pager, next"
        @current-change="changePage"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    // 列表数据
    keywordList: {
      type: Array,
      default: () => [],
    },
    // 分页器数据
    params: {
      type: Object,
      default: () => {
        return {
          page: 1,
          size: 10,
          total: 0,
        };
      },
    },
    // 是否加载中
    loading: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    changePage(page) {
      this.$emit("change-page", page);
    },
    formaterTime(row, column, cellValue, index) {
      const newTime = this.$moment(cellValue).format("YYYY-MM-DD HH:mm:ss");
      return newTime;
    },
    // 跳转编辑弹窗
    toEdit(row) {
      //   console.log("您点击了编辑");
      this.$emit("edit-keyword", row);
    },
    // 点击删除触发事件
    toDel(row) {
      //   console.log("您点击了删除", row);
      this.$http({
        url: `/brandKey/delete?brandId=${row.brandId}`,
        method: "delete",
      })
        .then((res) => {
          if (res.code === 200) {
            this.$message({
              message: "删除品牌成功",
              type: "success",
            });
            if (this.keywordList.length === 1 && this.params.page !== 1) {
              this.$emit("change-page", this.params.page - 1);
            } else {
              this.$emit("update");
            }
          } else {
            this.$message({
              message: res.message,
              type: "error",
            });
          }
        })
        .catch(() => {
          this.$message({
            message: "删除账号失败",
            type: "error",
          });
        });
    },
  },
};
</script>


<style lang="scss">
.no-margin {
  margin: 0;
}
.center-children {
  display: inline-flex;
  justify-content: center;
  align-items: center;
}
.pagination {
  text-align: right;
}
.table_content {
  width: 100%;
  display: flex;
  flex-direction: column;
  .keyword_table {
    flex: 1;
    height: 0;
  }
  .pagination {
    height: 32px;
  }
  .img_box {
    height: 100%;
    // display: flex;
    // align-items: center;
  }
  .logo {
    height: 100%;
    width: auto;
    // display: flex;
    // align-items: center;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/index/views/brandWord/keywordTable.vue